(function($) {
    window.PageFunctions.setup();
})(jQuery);
